import { LOCALE_ID, NgModule } from "@angular/core";
import { CommonModule, registerLocaleData } from "@angular/common";
import { AproveIdeaAuthorsComponent } from "./aprove-idea-authors/aprove-idea-authors.component";
import { RelevantInformationComponent } from "./relevant-information/relevant-information.component";
import { IndicatorsComponent } from "./indicators/indicators.component";
import { InputComponent } from "./input/input.component";
import { UploadFileComponent } from "./upload-file/upload-file.component";
import { IdeaFilesComponent } from "./idea-files/idea-files.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import localePt from "@angular/common/locales/pt";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { AuthorsComponent } from "./authors/authors.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxMaskModule } from "ngx-mask";

registerLocaleData(localePt, "pt-BR");

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AproveIdeaAuthorsComponent,
    RelevantInformationComponent,
    IndicatorsComponent,
    InputComponent,
    UploadFileComponent,
    AuthorsComponent,
    IdeaFilesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxMaskModule.forChild(),
  ],
  exports: [
    AproveIdeaAuthorsComponent,
    RelevantInformationComponent,
    IndicatorsComponent,
    InputComponent,
    UploadFileComponent,
    AuthorsComponent,
    IdeaFilesComponent,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "pt-BR",
    },
    TranslateService,
  ],
})
export class ComponentsModule {}
